import Notification from 'flarum/forum/components/Notification';
import app from 'flarum/forum/app';

export default class CaseMentorReviewRequestedNotification extends Notification {
  icon() {
    return 'fas fa-chalkboard-teacher';
  }

  href() {
    const data = this.attrs.notification.content() || {};
    return data.discussionId ? app.route('discussion', { id: data.discussionId }) : '#';
  }

  content() {
    const data = this.attrs.notification.content() || {};
    return '学员申请导师点评：' + (data.title || '案例');
  }

  excerpt() {
    return null;
  }
}
